module.exports = __webpack_public_path__ + "img/s06.8793541c.png";